export class RestartJob {

  constructor(
    public jobId?: number
  ) {
  }
}
